var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStarShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213,
    height: 197,
    viewBox: "0 0 213 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008200",
    fillRule: "evenodd",
    d: "M62.405 104.417l31.676 23.512-12.413 42.75c-12.41 8.55-24.828 17.1-36.814 26.077-4.704 1.278-4.704-2.565-2.14-8.978l20.98-65.406c-20.98-15.39-41.523-30.78-62.502-46.174-2.14-1.706-1.708-4.275 3.857-4.275l75.767.86C88.52 49.697 96.222 26.185 103.926 3.1c1.717-4.275 4.281-3.852 5.565-.428l23.116 70.964h77.479c2.14 0 2.572 1.71.856 2.993l-38.093 26.932h-42.806l-11.99-35.914c-.852-2.137-2.14-2.137-2.993 0l-12.418 35.486H62.405c-1.708 0-1.708.428 0 1.283",
    opacity: 0.055
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStarShape);
export default __webpack_public_path__ + "static/media/MenuStarShape.0d5be716d141e2f814613d910db902b2.svg";
export { ForwardRef as ReactComponent };